import { useEffect } from 'react';

const useOutsideClick = (ref, myCallBack, ignore = []) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [ref, myCallBack]);

  const handleClickOutside = (event) => {
    const shouldIgnore =
      typeof event.target.className === 'string' &&
      ignore.find((x) => event.target.className.includes(x));

    if (!shouldIgnore && ref.current && !ref.current.contains(event.target)) {
      myCallBack && myCallBack();
    }
  };
};

export default useOutsideClick;
